import { StyledLoadingPlaceholder, darkColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledLoading = styled.div<{
  width?: string;
  height?: string;
  margin?: string;
  mobileHeight?: string;
  mobileWidth?: string;
}>`
  ${StyledLoadingPlaceholder}
  background: linear-gradient(
    to right,
    ${darkColors.loading.primary},
    ${darkColors.loading.secondary},
    ${darkColors.loading.primary}
  );
  height: ${({ height }) => height ?? '3.6rem'};
  width: ${({ width }) => width ?? '100%'};
  margin: ${({ margin }) => margin ?? '0'};

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: ${({ mobileHeight }) => mobileHeight ?? 'auto'};
    width: ${({ mobileWidth }) => mobileWidth ?? '100%'};
  }
`;
